export default "__VITE_ASSET__42355e05__"